import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { useCommonStyles } from './styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  defaultLabel: {
    marginBottom: 8,
  },
  scoreCardWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    borderRadius: 8,
    border: (props) =>
      `1px solid ${theme.palette.matchingDetailsPage[props.mode].border}`,
    background: (props) => theme.palette.matchingDetailsPage[props.mode].bg,
    borderLeft: (props) =>
      `9px solid ${theme.palette.matchingDetailsPage[props.mode].border}`,
    padding: '0 24px',
  },
}));

const MatchingDetailsLabelValue = ({
  label = '',
  value = '-',
  labelClass = '',
  valueClass = '',
  styleVariant = 'default',
  mode,
}) => {
  const classes = useStyles({ mode });
  const commonClasses = useCommonStyles({ mode });

  const STYLE_MAP = {
    default: {
      wrapper: '',
      label: [classes.defaultLabel, commonClasses.fontRegularLight],
      value: [commonClasses.fontRegular],
    },
    scoreCard: {
      wrapper: [classes.scoreCardWrapper],
      label: [commonClasses.fontMediumBold],
      value: [commonClasses.fontRegular],
    },
  };

  return (
    <div className={clsx(...STYLE_MAP[styleVariant]?.wrapper)}>
      <Typography
        classes={{
          root: clsx(...STYLE_MAP[styleVariant]?.label, labelClass),
        }}
      >
        {label}
      </Typography>
      <Typography
        classes={{ root: clsx(...STYLE_MAP[styleVariant]?.value, valueClass) }}
      >
        {value}
      </Typography>
    </div>
  );
};

export default MatchingDetailsLabelValue;
